module.exports = __webpack_public_path__ + "static/media/webDev.a47e98e5.svg";